import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axios';
import { openInfoBox } from '../layout/slice';
import {BlackListRequest, BlackListResponse, BlackListRow, BlackListStateModel} from './models';
import { toast } from 'react-toastify';
import { AxiosError } from 'axios';
import { buildQueryString } from '../../utils/queryStringBuilder';

export const fetchBlackListRows = createAsyncThunk('black-list/fetch', async (blRequest: BlackListRequest): Promise<BlackListResponse> => {
  try {
    const pageNum = Number(blRequest.page) + 1;
    const params = {
      page: pageNum.toString(),
      pageSize: blRequest.pageSize?.toString(),
      locationUuidFilter: blRequest.locationUuidFilter,
      platesFilter: blRequest.platesFilter,
      sort: blRequest.sortBy,
      sortDirection: blRequest.sortOrder,
      fromDateFilter: blRequest.fromDateFilter,
      toDateFilter: blRequest.toDateFilter,
      daysOfWeekFilter: blRequest.daysOfWeekFilter?.join(','),
      fromHourFilter: blRequest.fromHourFilter,
      toHourFilter: blRequest.toHourFilter,
    };

    const queryString = buildQueryString(params);
    const url = `/v1/location/${blRequest.mainLocationId}/black-list?${queryString}`;
    const response = await axiosInstance.get<BlackListResponse>(url);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const saveBlackList = createAsyncThunk('black-list/save', async (entry: BlackListRow, thunkAPI): Promise<boolean> => {
  console.log('save - black list entry');
  try {
    if (entry?.uuid) {
      await axiosInstance.put<BlackListStateModel>(`/v1/location/${entry.locationUuid}/black-list/${entry.uuid}`, entry);
    } else {
      await axiosInstance.post<BlackListStateModel>(`/v1/location/${entry?.locationUuid}/black-list`, entry);
    }
    thunkAPI.dispatch(openInfoBox('Wiersz został zaapisany.'));
    return true;
  } catch (error) {
    const typedError = error as AxiosError;
    console.log(typedError);
    toast.error(typedError?.message);
    console.log(error);
    return false;
  }
});

export const deleteBlackList = createAsyncThunk('black-list/delete', async (entry: BlackListRow, thunkAPI): Promise<string> => {
  console.log('delete - black list entry');
  try {
    await axiosInstance.delete<BlackListStateModel>(`/v1/location/${entry.locationUuid}/black-list/${entry.uuid}`);
    thunkAPI.dispatch(openInfoBox('Wiersz został usunięty.'));
    return entry.uuid;
  } catch (error) {
    console.log(error);
  }
  return '';
});

const createUrl = (endpoint: string, filters: BlackListRequest) => {
  let url = `/v1/location/${filters.mainLocationId}/black-list/${endpoint}`;

  if (filters.locationUuidFilter && filters.locationUuidFilter !== 'ALL') {
    url += '?locationUuidFilter=' + filters.locationUuidFilter;
  }
  return url;
};


export const exportData = createAsyncThunk('black-list/export', async (filters: BlackListRequest): Promise<string> => {
    try{
        const result = await axiosInstance.get(createUrl('/export', filters));
        let csvContent = 'data:text/csv;charset=utf-8,' + result.data;
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement('a');
        link.setAttribute('href', encodedUri);
        const dateStr = new Date().toISOString();
        link.setAttribute('download', `biale_listy_${dateStr}.csv`);
        document.body.appendChild(link);
        link.click();
    return result.data;
    } catch (error) {
        console.error(error);
        throw error;
    }
});